import { PropsWithChildren } from "react";

import { colors } from "#app/theme/v1/colors";
import { ButtonProps } from "#shared/view/designSystem/Button";
import { UnstyledButton } from "#shared/view/designSystem/UnstyledButton";

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  linkColor?: string;
  props?: ButtonProps;
};

export const ButtonLink = ({
  onClick,
  linkColor = colors.gray[4],
  children,
  ...props
}: PropsWithChildren & Props) => {
  return (
    <UnstyledButton onClick={onClick} ta={"center"} c={linkColor} td={"underline"} {...props}>
      {children}
    </UnstyledButton>
  );
};
